module.exports = __webpack_public_path__ + "laserove-beleni-zubu_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_6.jpg
// module id = 914
// module chunks = 0